// Registre des dictionnaires.
//
// fr/ est la langue SOURCE ; nl/, de/, es/, en/ et lb/ sont des dossiers de
// fragments portant exactement les mêmes clés (plus les clés packs.*, qui
// n'existent pas en français puisque les textes produit y viennent de la base).
//
// ⚠️ PIÈGE DÉJÀ RENCONTRÉ : si un fichier plat `de.js` cohabite avec le dossier
// `de/`, Node résout `./de` vers le FICHIER, jamais vers le dossier. La
// traduction entière serait ignorée en silence — build vert, aucune erreur, et
// le site sert du français sous une étiquette allemande. Ne jamais laisser
// traîner un tel fichier après avoir créé le dossier.
//
// pt.js reste un fichier vide : le portugais est promis sur la boîte, mais on
// ne livre plus au Portugal. Le seuil de langues disponibles le garde masqué.
import fr from './fr';
import en from './en';
import nl from './nl';
import de from './de';
import lb from './lb';
import es from './es';
import pt from './pt';

import { languesDisponibles } from './languages';

export const DICTIONARIES = { fr, en, nl, de, lb, es, pt };

/**
 * Les langues à proposer au visiteur : celles dont le dictionnaire est
 * réellement rempli. Calculé ici parce que c'est le seul module qui connaît
 * les dictionnaires (languages.js reste une simple description des langues,
 * sans dépendance).
 */
export const LANGUES_DISPONIBLES = languesDisponibles(DICTIONARIES);
